import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import webClient from '../../core/web_client';
import { EVENT_REGISTERS_PATH } from '../../core/constants';
import { extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';

export const createEventRegisterAction = createAsyncThunk(
    'pod/createEventRegisterAction',
    async (data, { fulfillWithValue, rejectWithValue }) => {
        try {
            const response = await webClient.post(EVENT_REGISTERS_PATH, data);
            return fulfillWithValue(extractResponseData(response));
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const createEventRegisterSlice = createSlice({
    name: 'createEventRegisterSlice',
    initialState: DEFAULT_STATE,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(createEventRegisterAction.pending, () => STATE__API__STARTED);
        builder.addCase(createEventRegisterAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(createEventRegisterAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const createEventRegisterState = (state) => state.pod.createEventRegister;
export default createEventRegisterSlice.reducer;